<form #formParticipant="ngForm" novalidate autocomplete="off" (submit)="onSubmit()">
    <div class="container">
        <div class="row">
            <div class="col-12">
                <div class="row flex-nowrap justify-content-between align-items-end">
                    <div class="col-auto flex-shrink-1">
                        <h1 class="text-blue mat-display-1 font-weight-bold mb-0">
                            <span *ngIf="!isLegalPerson">{{ 'form.new-participant' | translate }}</span>
                            <span *ngIf="isLegalPerson" [ngSwitch]="client.type">
                                <ng-container *ngSwitchCase="ClientType.LEGAL_PERSON">{{ 'form.business' | translate }}</ng-container>
                                <ng-container *ngSwitchDefault>{{ 'form.new-attorney-in-fact' | translate }}</ng-container>
                            </span>
                        </h1>
                    </div>
                    <div class="col-auto" [ngSwitch]="client.type">
                        <i class="icon-legal text-blue" *ngSwitchCase="ClientType.LEGAL_PERSON"></i>
                        <i class="icon-disabled-plus text-blue" *ngSwitchCase="ClientType.DISABLED"></i>
                        <i class="icon-minor-plus text-blue" *ngSwitchCase="ClientType.MINOR"></i>
                        <i class="icon-natural-plus text-blue" *ngSwitchDefault></i>
                    </div>
                </div>
                <hr class="mt-1 mb-4" />

                <ng-container *ngIf="isLegalPerson">
                    <div class="row">
                        <div class="col-12">
                            <label>{{ 'form.participant-type' | translate }}</label
                            ><br />
                            <mat-radio-group name="type" [disabled]="isFirst" [(ngModel)]="client.type" [required]="true">
                                <mat-radio-button class="mr-5" name="natural" color="blue-gray" [value]="ClientType.NATURAL_PERSON">
                                    {{ 'form.natural' | translate }}
                                </mat-radio-button>
                                <mat-radio-button class="ml-5" name="legal" color="blue-gray" [value]="ClientType.LEGAL_PERSON">
                                    {{ 'form.legal' | translate }}
                                </mat-radio-button>
                            </mat-radio-group>
                        </div>
                    </div>
                    <hr class="gray my-2" />
                </ng-container>

                <ng-container *ngIf="!isLegalPerson">
                    <div class="row justify-content-between">
                        <div class="col-12 col-md-auto mb-2 mb-md-0">
                            <label class="d-block">{{ 'form.ownership-relationship' | translate }}</label>
                            <mat-radio-group
                                name="pPosition"
                                [(ngModel)]="client.relation"
                                [required]="true"
                                [disabled]="isFirst || client.type === ClientType.MINOR || client.type === ClientType.DISABLED"
                            >
                                <div class="row">
                                    <div class="col-12 col-sm-auto">
                                        <mat-radio-button name="pCoOwner" color="blue-gray" [value]="ClientRelation.HOLDER">
                                            {{ 'form.co-holder' | translate }}
                                        </mat-radio-button>
                                    </div>
                                    <div class="col-12 col-sm-auto">
                                        <mat-radio-button name="pAuthorized" color="blue-gray" [value]="ClientRelation.AUTHORIZED">
                                            {{ 'form.authorized' | translate }}
                                        </mat-radio-button>
                                    </div>
                                </div>
                            </mat-radio-group>
                        </div>
                        <div class="col-12 col-md-auto">
                            <label class="d-block">{{ 'form.participant-is' | translate }}</label>
                            <mat-radio-group
                                name="pType"
                                [(ngModel)]="client.type"
                                [required]="true"
                                [disabled]="isEditing || client.disabled || client.relation === ClientRelation.AUTHORIZED"
                            >
                                <div class="row">
                                    <div class="col-12 col-sm-auto">
                                        <mat-radio-button name="pNaturalPerson" color="blue-gray" [value]="ClientType.NATURAL_PERSON">
                                            {{ 'form.natural-person' | translate }}
                                        </mat-radio-button>
                                    </div>
                                    <div class="col-12 col-sm-auto">
                                        <mat-radio-button name="pMinorPerson" color="blue-gray" [value]="ClientType.MINOR">
                                            {{ 'form.minor-person' | translate }}
                                        </mat-radio-button>
                                    </div>
                                    <div class="col-12 col-sm-auto">
                                        <mat-radio-button name="pDisabledPerson" color="blue-gray" [value]="ClientType.DISABLED">
                                            {{ 'form.disabled-person' | translate }}
                                        </mat-radio-button>
                                    </div>
                                </div>
                            </mat-radio-group>
                        </div>
                    </div>
                    <hr class="gray my-2" />
                </ng-container>
            </div>
        </div>
    </div>

    <ng-container [ngSwitch]="client.type">
        <ng-container *ngSwitchCase="ClientType.DISABLED">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <h2 class="mat-subheading-1 text-blue font-weight-bold mb-3">
                            {{ 'form.disabled-data' | translate }}
                        </h2>
                    </div>
                </div>
            </div>
            <thr-contract-form-participant-minor-disabled-person
                [client]="client"
                [tutors]="tutors"
                (addingTutor)="onAddingTutor($event)"
            ></thr-contract-form-participant-minor-disabled-person>
        </ng-container>
        <ng-container *ngSwitchCase="ClientType.MINOR">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <h2 class="mat-subheading-1 text-blue font-weight-bold mb-3">
                            {{ 'form.minor-data' | translate }}
                        </h2>
                    </div>
                </div>
            </div>
            <thr-contract-form-participant-minor-disabled-person
                [client]="client"
                [tutors]="tutors"
                (addingTutor)="onAddingTutor($event)"
            ></thr-contract-form-participant-minor-disabled-person>
        </ng-container>
        <ng-container *ngSwitchCase="ClientType.LEGAL_PERSON">
            <div class="container" *ngIf="!isFirst">
                <div class="row flex-nowrap align-items-center mt-3 mb-4">
                    <div class="col-auto">
                        <i class="icon-exclamation red-icon-exclamation"></i>
                    </div>
                    <div class="col-auto flex-shrink-1">
                        <input
                            type="checkbox"
                            class="d-none"
                            name="disabledLegal"
                            id="disabledLegal"
                            required
                            [(ngModel)]="disabledLegal"
                        />
                        <p class="text-error font-weight-bold mb-0">
                            {{ 'form.legal-error' | translate }}
                        </p>
                    </div>
                </div>
            </div>
            <div class="pt-3" *ngIf="isFirst">
                <thr-contract-form-participant-legal-person [client]="client"></thr-contract-form-participant-legal-person>
            </div>
        </ng-container>
        <ng-container *ngSwitchDefault>
            <div class="pt-3">
                <thr-contract-form-participant-natural-person
                    [client]="client"
                    [isFirst]="isFirst"
                ></thr-contract-form-participant-natural-person>
            </div>
        </ng-container>
    </ng-container>

    <div class="container">
        <div
            class="row justify-content-between"
            [class.mt-4]="client.type === ClientType.NATURAL_PERSON"
            [class.mt-2]="client.type !== ClientType.NATURAL_PERSON"
        >
            <div class="col-12" *ngIf="isClientPortal">
                <div
                    #recaptchaDirective="recaptcha"
                    thr-recaptcha
                    name="recaptcha"
                    [(ngModel)]="client.recaptchaToken"
                    #recaptchaCtrl="ngModel"
                ></div>
            </div>
            <div class="col-12 col-md-4 mb-3 mb-md-0">
                <button type="button" class="full-width mat-elevation-z0" mat-raised-button color="blue" (click)="onCancel()">
                    {{ 'general.cancel' | translate }}
                </button>
            </div>
            <div class="col-12 col-md-4 mb-3 mb-md-0" *ngIf="showAddingTutorButton">
                <button type="button" class="full-width mat-elevation-z0" mat-raised-button color="blue" (click)="onAddTutor()">
                    <span *ngIf="client.type === ClientType.DISABLED">{{ 'form.add-other-representative' | translate }}</span>
                    <span *ngIf="client.type === ClientType.MINOR">{{ 'form.add-other-tutor' | translate }}</span>
                </button>
            </div>
            <div class="col-12 col-md-4 mb-3 mb-md-0">
                <button
                    type="submit"
                    class="full-width mat-elevation-z0"
                    mat-raised-button
                    color="blue"
                    [disabled]="!formParticipant.valid"
                >
                    {{ 'general.next' | translate }}
                </button>
            </div>
        </div>
    </div>
</form>
